import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { RTKQueryHook, RTKQueryResultType } from '../../../../data/baseApi'
import { getSelectedClientId } from '../../../../data/lyraTherapy/clientSelectors'
import { useGetAllClientEpisodesQuery } from '../episodesApi'

export const useAllEpisodesForSelectedClient: RTKQueryHook<typeof useGetAllClientEpisodesQuery> = () => {
  const selectedClientId = useSelector(getSelectedClientId)
  return useGetAllClientEpisodesQuery(
    selectedClientId ? { patientId: selectedClientId } : skipToken,
  ) as RTKQueryResultType<typeof useGetAllClientEpisodesQuery>
}
